import {
  UPLOAD_IMAGE,
} from '@/api/modules/upload.api';

export default {
  uploadImage({ commit, state }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error);
      }
    };
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response);
      }
    };
    UPLOAD_IMAGE({ payload }, successCallback, errorCallback);
  },
};
